// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__hhQUv","colMin":"styles_colMin__1jLuJ","colCheckbox":"styles_colCheckbox__3dL5r"};